module.exports = __webpack_public_path__ + "img/automat-outlines.e41a3d23.png";